import { Fragment, forwardRef, useMemo } from 'react';
import { Overlay, Popover, PopoverContent } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useStorage64 } from 'hooks';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { SETTINGS_POPOVER_PATHS } from 'config/settingsPopoverPaths';
import styles from './settingPopover.module.scss';
import './styles.scss';

const SettingPopover = forwardRef(({ show, target }, ref) => {
  const [giftTable] = useStorage64(CURRENT_GIFT_TABLE, null);

  const paths = useMemo(() => {
    if (!giftTable) {
      return SETTINGS_POPOVER_PATHS.filter(({ path }) => path !== '/mis-mesas');
    }
    return SETTINGS_POPOVER_PATHS;
  }, [giftTable]);

  return (
    <Overlay
      show={show}
      target={target}
      placement="bottom"
      container={ref}
      containerPadding={20}
    >
      <Popover id="popover-contained">
        <PopoverContent className={styles.cartPopover}>
          <section className={styles.container}>
            {paths.map(({ path, label }, index) => (
              <Fragment key={path}>
                <Link to={path}>
                  <div className="mt-1 h6 text-dark">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{label}</div>
                </Link>
                {index !== paths.length - 1 && <hr />}
              </Fragment>
            ))}
          </section>
        </PopoverContent>
      </Popover>
    </Overlay>
  );
});

export default SettingPopover;
